import Vue from 'vue'
import {Input, Button} from 'ant-design-vue'

import httpManager from '../../util/common'
Vue.use(Input)
Vue.use(Button)
let vm = {
  delimiters: ['{', '}'],
  data: () => {
    return {
      company_name: '',
      entity: null,
      hints: [],
      showHintsBox: false,
      activeNo: -1,
      closeClick: false
    }
  },
  computed: {
    entityNamePlaceHolder () {
      return this.$t('topNavBar.entityNamePlaceHolder')
    }
  },
  methods: {

    showEntity () {
      let self = this
      let params = new Map()
      params.set('keyword', self.company_name)
      httpManager('entity_search', params)
        .then(response => {
          // this.$router.push({path:  '/entity/'+response.data[0].oa_id})
          const {
            href
          } = this.$router.resolve({path: '/entity/' + response.data[0].oa_id + '/home'})
          window.open(href, '_blank')
        })
        .catch(error => {
          console.log(error)
        })
    },
    companyComplete () {
      let self = this
      let params = new Map()
      params.set('keyword', self.company_name)
      httpManager('entity_fix', params)
        .then(response => {
          self.hints = response.data.map(x => x.full_short_ent_ticker)
          self.showHintsBox = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    fillInput: function (index) {
      this.showHintsBox = false
      this.closeClick = true
      if(this.hints && this.hints[index]){
        let value = this.hints[index]
        this.hints = []
        this.company_name = value
      }
    },
    closeHintsBox: function () {
      let self = this
      setTimeout(function () {
        self.showHintsBox = false
        self.hints = []
      }, 250)
    }
  },
  mounted () {
  },
  watch: {
    company_name: function () {
      // this.companyComplete();
      if (!this.closeClick) {
        if(this.company_name==='') {
          this.closeHintsBox()
          return
        }
        let last = this.company_name
        setTimeout(()=>{
          if(last === this.company_name){
            this.companyComplete()
          }
        },500)
      } else {
        this.closeClick = false
      }
    }
  }
}
Vue.component('entity-search', vm)
export default vm



// WEBPACK FOOTER //
// ./src/home/js/entity_search.js